// extracted by mini-css-extract-plugin
module.exports = {"notice":"Badge_notice___--Sb","notice__button":"Badge_notice__button__1wjPy"};